// assets/filter-collection.js
(() => {
  console.log('Filter collection script loaded');
  let sectionType = "search";
  const isCollectionsPath = /^\/collections(\/|$)/i.test(location.pathname);
  if (isCollectionsPath) sectionType = "main-collection";
  console.log('Section type:', sectionType, 'Path:', location.pathname);

  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const getForms = () => qsa("[data-filters-form]");

  const closeAllFilterGroups = (except = null) => {
    qsa(".filter-group.open").forEach((g) => {
      if (g === except) return;
      g.classList.remove("open");
      g.querySelector("[data-filter-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      g.querySelector(".filter-group__options")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });
  };

  const closeAllSortGroups = (except = null) => {
    qsa(".sort-group.open").forEach((g) => {
      if (g === except) return;
      g.classList.remove("open");
      g.querySelector("[data-sort-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      g.querySelector("[data-sort-options]")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });
  };

  const getCheckedFilters = () =>
    qsa('[data-filters-form] input[type="checkbox"]:checked').map((cb) => ({
      name: cb.name.endsWith("[]") ? cb.name.slice(0, -2) : cb.name,
      value: cb.value,
    }));

  const getSortValue = () => {
    // prefer any explicit sort_by hidden input; they should be in sync
    const inp = document.querySelector(
      '[data-filters-form] input[name="sort_by"]'
    );
    return inp ? inp.value : "";
  };

  const setSortValueEverywhere = (value) => {
    let form = document.querySelector("[data-filters-form]");
    const inp = form.querySelector('input[name="sort_by"]');

    console.log(inp)
    if (inp) inp.value = value;    
  };


  const mirrorCheckboxes = (name, value, checked) => {
    qsa(
      `[data-filters-form] input[type="checkbox"][name="${CSS.escape(
        name
      )}"][value="${CSS.escape(value)}"]`
    ).forEach((el) => {
      el.checked = checked;
    });
  };

const buildQueryParams = (page = 1) => {
  const params = new URLSearchParams();

  const form = document.querySelector("[data-filters-form]");
  if (!form) return params;

  const formData = new FormData(form);

  for (const [name, value] of formData.entries()) {
    if (String(value).trim() !== "") {
      params.append(name, value);
    }
  }

  params.set("page", String(page));

  return params;
};

  // 1) Clear filters
  document.addEventListener("click", (e) => {
    const clearBtn = e.target.closest("[data-clear-filters]");
    if (!clearBtn) return;

    e.preventDefault();
    qsa('[data-filters-form] input[type="checkbox"]').forEach(
      (cb) => (cb.checked = false)
    );
    applyFilters(1, false);
  });

  // 2) Apply filters button
  document.addEventListener("click", (e) => {
    const applyBtn = e.target.closest(".filter-drawer__apply");
    if (!applyBtn) return;

    e.preventDefault();
    // console.log('Apply button clicked - applying filters');
    applyFilters(1, false);
    
    // Close the filter drawer after applying
    const drawer = document.querySelector('#FilterDrawer');
    const toggle = document.querySelector('.collection-filter-toggle');
    if (drawer && toggle) {
      drawer.classList.remove('filter-drawer--open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });

  // 2) Filter dropdown toggle
  document.addEventListener("click", (e) => {
    const filterToggle = e.target.closest("[data-filter-toggle]");
    if (filterToggle) {
      const group = filterToggle.closest("[data-filter-group]");

      closeAllFilterGroups(group);
      closeAllSortGroups();

      const isOpen = group.classList.toggle("open");
      filterToggle.setAttribute("aria-expanded", String(isOpen));
      group
        .querySelector(".filter-group__options")
        ?.setAttribute("aria-hidden", String(!isOpen));
      return;
    }
    // Only close filter groups if clicking outside the filter drawer entirely
    if (!e.target.closest("[data-filter-group]") && !e.target.closest(".filter-drawer")) {
      qsa(".filter-group.open").forEach((g) => {
        g.classList.remove("open");
        g.querySelector("[data-filter-toggle]")?.setAttribute(
          "aria-expanded",
          "false"
        );
        g.querySelector(".filter-group__options")?.setAttribute(
          "aria-hidden",
          "true"
        );
      });
    }
  });

  // 3) Sort dropdown toggle
  document.addEventListener("click", (e) => {
    const sortToggle = e.target.closest("[data-sort-toggle]");
    if (sortToggle) {
      const group = sortToggle.closest("[data-sort-group]");

      closeAllSortGroups(group);
      closeAllFilterGroups();

      const isOpen = group.classList.toggle("open");
      sortToggle.setAttribute("aria-expanded", String(isOpen));
      group
        .querySelector("[data-sort-options]")
        ?.setAttribute("aria-hidden", String(!isOpen));
      return;
    }
    if (!e.target.closest("[data-sort-group]")) {
      qsa(".sort-group.open").forEach((g) => {
        g.classList.remove("open");
        g.querySelector("[data-sort-toggle]")?.setAttribute(
          "aria-expanded",
          "false"
        );
        g.querySelector("[data-sort-options]")?.setAttribute(
          "aria-hidden",
          "true"
        );
      });
    }
  });

  // 4) Sort option selection (sync both UIs)
  document.addEventListener("click", (e) => {
    const sortOption = e.target.closest(".sort-group__option");
    if (!sortOption) return;

    const value = sortOption.dataset.sortValue || "";
    const label = sortOption.textContent.trim();

    console.log('Sort option selected:', value, label);

    // Update hidden inputs + labels everywhere
    setSortValueEverywhere(value);

    // Close all sort dropdowns
    qsa(".sort-group.open").forEach((g) => {
      g.classList.remove("open");
      g.querySelector("[data-sort-toggle]")?.setAttribute(
        "aria-expanded",
        "false"
      );
      g.querySelector("[data-sort-options]")?.setAttribute(
        "aria-hidden",
        "true"
      );
    });

    applyFilters(1, false);
  });

  // 5) Prevent native submit
  document.addEventListener("submit", (e) => {
    if (!e.target.matches("[data-filters-form]")) return;
    e.preventDefault();
    // console.log('Form submitted, applying filters...');
    applyFilters(1, false);
  });

  // 6) Form submission prevention
  document.addEventListener("submit", (e) => {
    if (e.target.matches('[data-filters-form]')) {
      e.preventDefault();
      // console.log('Form submission prevented - using AJAX instead');
    }
  });

  // 7) Checkbox change → mirror & apply
  document.addEventListener("change", (e) => {
    const cb = e.target;
    // console.log('Change event on:', cb, 'matches checkbox:', cb.matches('[data-filters-form] input[type="checkbox"]'));
    if (!cb.matches('[data-filters-form] input[type="checkbox"]')) return;

    // console.log('Checkbox changed:', cb.name, cb.value, cb.checked);

    // Mirror to the other form(s)
    mirrorCheckboxes(cb.name, cb.value, cb.checked);

    applyFilters(1, false);
  });

  // 7) Load more
  document.addEventListener("click", (e) => {
    const loadBtn = e.target.closest("[data-load-more]");
    if (!loadBtn) return;
    const nextPage = parseInt(loadBtn.dataset.nextPage || "2", 10);
    applyFilters(nextPage, true);
  });

  // 8) Core AJAX + DOM update
  async function applyFilters(page = 1, append = false) {
    const section = document.querySelector(
      `[data-section-type="${sectionType}"]`
    );
    if (!section) {
      console.warn(`Section with data-section-type="${sectionType}" not found`);
      return;
    }

    let container;
    let containerId;
    let sectionId;
    let params;
    let base;
    let fetchUrl;
    let qs;
    let json;
    let tmp;
    let incomingRoot;
    let newSection;

    section.classList.add("is-loading");

    if (sectionType == "search") {
      container = section.closest(".shopify-section") || section;
      containerId = container.getAttribute("id") || "";
      sectionId = containerId.startsWith("shopify-section-")
        ? containerId.replace("shopify-section-", "")
        : section.getAttribute("data-section-id") || "search";

      params = buildQueryParams(page) || new URLSearchParams();
      if (!params.get("page")) params.set("page", String(page));

      if (!params.get("q")) {
        // last-ditch: try to read current search term from URL
        const currentQ = new URL(location.href).searchParams.get("q");
        if (currentQ) params.set("q", currentQ);
      }
      if (!params.get("type")) params.set("type", "product");

      base = "/search";
      fetchUrl = `${base}?sections=${encodeURIComponent(sectionId)}${
        params.toString() ? `&${params.toString()}` : ""
      }`;
    } else {
      params = buildQueryParams(page);

      // ADDED: forsiraj sort_by iz hidden inputa u params
      const sortInput = document.querySelector('[data-filters-form] input[name="sort_by"]');
      if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);

      base = window.location.pathname;
      qs = params.toString();
      const sectionId = section.getAttribute('data-section-id');
      fetchUrl = `${base}?sections=${sectionId}${qs ? `&${qs}` : ""}`;
    }

    try {
      // console.log('Fetching URL:', fetchUrl);
      const res = await fetch(fetchUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin",
      });
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      json = await res.json();
      // console.log('Response received:', json);
      // console.log('Section ID:', section.getAttribute('data-section-id'));
      // console.log('Looking for key:', `shopify-section-${section.getAttribute('data-section-id')}`);
    } catch (err) {
      console.error("Filter AJAX error:", err);
      section.classList.remove("is-loading");
      return;
    }

    if (sectionType == "search") {
      const html = json?.[sectionId];
      if (!html) {
        console.warn("[filters] No HTML for section id:", sectionId, json);
        section.classList.remove("is-loading");
        return;
      }
      tmp = document.createElement("div");
      tmp.innerHTML = html;

      // 1) Replace ONLY inner HTML of the section root (preserve attributes/listeners on the node itself)
      if (!append) {
        incomingRoot =
          tmp.querySelector(`#shopify-section-${CSS.escape(sectionId)}`) ||
          tmp.firstElementChild;
        if (incomingRoot) {
          section.innerHTML = incomingRoot.innerHTML;
        }
      }
    } else {
      tmp = document.createElement("div");
      const sectionId = section.getAttribute('data-section-id');
      const availableKeys = Object.keys(json);
      // console.log('Available keys in response:', availableKeys);
      // console.log('First key:', availableKeys[0]);
      // console.log('Full response object:', json);
      
      // Try the first key if our expected key doesn't exist
      const sectionHtml = json[`shopify-section-${sectionId}`] || json[availableKeys[0]];
      if (!sectionHtml) {
        console.warn("[filters] No HTML for section id:", sectionId, json);
        section.classList.remove("is-loading");
        return;
      }
      tmp.innerHTML = sectionHtml;
      // console.log('Parsed HTML:', tmp.innerHTML.substring(0, 500) + '...');

      // Replace ONLY inner content of <section>, preserving attributes
      if (!append) {
        newSection = tmp.querySelector(`[data-section-type="${sectionType}"]`);
        // console.log('Found new section:', newSection);
        if (newSection) {
          // Update the product grid content
          const newGrid = newSection.querySelector("[data-product-grid]");
          const oldGrid = section.querySelector("[data-product-grid]");
          // console.log('New grid:', newGrid);
          // console.log('Old grid:', oldGrid);
          if (newGrid && oldGrid) {
            oldGrid.innerHTML = newGrid.innerHTML;
            // console.log('Updated grid content');
          }
          
          // Update the collection count
          const newCount = newSection.querySelector(".collection-count");
          const oldCount = section.querySelector(".collection-count");
          // console.log('New count:', newCount);
          // console.log('Old count:', oldCount);
          if (newCount && oldCount) {
            oldCount.innerHTML = newCount.innerHTML;
            // console.log('Updated count content');
          }
          
          // Update the active filters
          const newActiveFilters = newSection.querySelector(".active-filters");
          const oldActiveFilters = section.querySelector(".active-filters");
          // console.log('New active filters:', newActiveFilters);
          // console.log('Old active filters:', oldActiveFilters);
          if (newActiveFilters && oldActiveFilters) {
            oldActiveFilters.innerHTML = newActiveFilters.innerHTML;
            // console.log('Updated active filters content');
          } else if (newActiveFilters && !oldActiveFilters) {
            // Insert active filters after toolbar if they don't exist
            const toolbar = section.querySelector(".collection-toolbar");
            if (toolbar) {
              toolbar.insertAdjacentElement('afterend', newActiveFilters);
              // console.log('Inserted new active filters');
            }
          } else if (!newActiveFilters && oldActiveFilters) {
            // Remove active filters if they no longer exist
            oldActiveFilters.remove();
            // console.log('Removed old active filters');
          }
          const newSortGroup = newSection.querySelector(".sort-group");
          const oldSortGroup = section.querySelector(".sort-group");
          if (newSortGroup && oldSortGroup) {
            oldSortGroup.innerHTML = newSortGroup.innerHTML;
          }
        } else {
          console.warn('No section found with data-section-type="main-collection"');
        }
      }
    }

    // Grid update (append or replace)
    const newGrid = tmp.querySelector("[data-product-grid]");
    const oldGrid = document.querySelector("[data-product-grid]");
    if (newGrid && oldGrid) {
      if (append) {
        oldGrid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
      } else {
        oldGrid.outerHTML = newGrid.outerHTML;
      }
    }

    // Load more
    const newLoadWrap = tmp.querySelector("[data-load-more-container]");
    const oldLoadWrap = document.querySelector("[data-load-more-container]");
    if (newLoadWrap) {
      if (append && oldLoadWrap) {
        const newBtn = newLoadWrap.querySelector("[data-load-more]");
        const oldBtn = oldLoadWrap.querySelector("[data-load-more]");
        if (newBtn && oldBtn) oldBtn.dataset.nextPage = newBtn.dataset.nextPage;
      } else if (!append && oldLoadWrap) {
        oldLoadWrap.outerHTML = newLoadWrap.outerHTML;
      }
    } else if (append && oldLoadWrap) {
      oldLoadWrap.remove();
    }

    // URL update on fresh filter/sort
    if (!append) {
      const qs = params.toString();
      const cleanQS = qs.replace(/(^|&)page=\d+(&|$)/, "$1");
      const newUrl = cleanQS ? `${base}?${cleanQS}` : base;
      history.replaceState(null, "", newUrl);
    }

    // Done
    const refreshed = document.querySelector(
      `[data-section-type="${sectionType}"]`
    );
    if (refreshed) refreshed.classList.remove("is-loading");
  }
})();
